export const COLORS = {
  PRIMARY_BLUE: '#1890ff',
  PRIMARY_BLUE_LIGHT: '#e6f7ff',

  SUCCESS_GREEN: '#52c41a',
  SUCCESS_GREEN_BG: '#f6ffed',
  SUCCESS_GREEN_BORDER: '#b7eb8f',

  WHITE: '#fff',
  GRAY_LIGHT: '#f5f5f5',
  GRAY_MEDIUM: '#595959',
  GRAY_DARK: '#666',
  GRAY_BORDER: '#f0f0f0',
  GRAY_BG: '#fafafa',
  GRAY_BORDER_DARK: '#d9d9d9',

  CANDIDATES_CARD: '#4dd0e1',
  REFERRALS_CARD: '#ec407a',
  APPLICATIONS_CARD: '#7e57c2',

  TIMELINE_REFERRAL: '#1890ff',
  TIMELINE_APPLICATION: '#52c41a',
  TIMELINE_SUBMISSION: '#fa8c16',

  WHITE_95: 'rgba(255,255,255,0.95)',
  WHITE_90: 'rgba(255,255,255,0.9)',
  WHITE_80: 'rgba(255,255,255,0.8)',
  WHITE_60: 'rgba(255,255,255,0.6)',
  WHITE_20: 'rgba(255,255,255,0.2)',
  BLACK_10: 'rgba(0,0,0,0.1)',
  TIMELINE_LINE: 'rgba(0, 0, 0, 0.10)',

  DEFAULT_BRAND: '#667eea'
};

export const STATUS_COLORS = {
  'var(--tan-hide)': '#d4a373',
  'var(--old-mandarin)': '#ff6b35',
  'var(--fern)': '#228b22',
  'var(--forest-green)': '#228b22',
  'var(--oslo-gray)': '#595959',
  'var(--sunset-orange)': '#ff6347',
  'var(--royal-blue)': '#4169e1',
  'var(--mellow-yellow)': '#ffdb58',
  'var(--deep-blush)': '#ff69b4'
};

export const TYPOGRAPHY = {
  FONT_SIZES: {
    XS: '11px',
    SM: '12px',
    MD: '13px',
    BASE: '14px',
    LG: '16px'
  }
};

export const SPACING = {
  XS: '2px',
  SM: '8px',
  MD: '12px',
  LG: '16px',
  XL: '24px',
  XXL: '32px'
};

export const BORDER_RADIUS = {
  SMALL: '4px',
  DEFAULT: '16px',
  ROUND: '50%'
};

export const SHADOWS = {
  CARD: '0 8px 32px rgba(0,0,0,0.1)'
};